import { render, staticRenderFns } from "./HeaderModal.vue?vue&type=template&id=48cf4649&"
import script from "./HeaderModal.vue?vue&type=script&lang=ts&"
export * from "./HeaderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports